import React, { createContext, useContext, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../services/store';
import { SessionService } from '../services/session/SessionService';

interface SessionContextValue {
  isInCooldown: boolean;
  shouldShowModal: boolean;
  debugInfo: {
    timeSinceLogin: number;
    inCooldown: boolean;
    shouldFullLogout: boolean;
    shouldShowReAuth: boolean;
  };
}

const SessionContext = createContext<SessionContextValue | null>(null);

export function SessionProvider({ children }: { children: ReactNode }) {
  const authModalState = useSelector((state: RootState) => state.authModal!);
  const isLoggedIn = useSelector((state: RootState) => !!state.authorisation?.auth?.token);

  const sessionState = {
    lastLoginTimestamp: authModalState.lastLoginTimestamp,
    sessionWarningShown: authModalState.sessionWarningShown,
    isLoggedIn,
  };

  const value: SessionContextValue = {
    isInCooldown: SessionService.isInCooldown(sessionState.lastLoginTimestamp),
    shouldShowModal: SessionService.shouldShowModalFor401(sessionState),
    debugInfo: SessionService.getDebugInfo(sessionState),
  };

  return (
    <SessionContext.Provider value={value}>
      {children}
    </SessionContext.Provider>
  );
}

export function useSessionContext() {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSessionContext must be used within a SessionProvider');
  }
  return context;
}
